import styled from 'styled-components';

export const LayoutWrapper = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
`;
